import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { buildChequeLogMessage } from 'helpers/chequeLogMessage'

import { formatPosDate } from 'pages/admin/sql/format'

/** jsonb с чужой кассы может прийти и объектом, и строкой. */
function parseJson(value) {
	if (!value) return null
	if (typeof value === 'object') return value

	try {
		return JSON.parse(value)
	} catch (error) {
		return null
	}
}

/**
 * История чека — та же таблица, что в кассе (ClosedCheques, модалка
 * «История чека»): те же колонки, тот же разбор params в текст, тот же
 * формат даты. Смысл монитора в том, чтобы при разговоре с точкой обе
 * стороны смотрели на одно и то же, поэтому вид не «свой, но похожий».
 */
function ChequeLogsModal({ show, onHide, cheque, logs, loading }) {
	const { t } = useTranslation()

	function logMessage(params) {
		return buildChequeLogMessage(parseJson(params), t)
	}

	/** История в файл: её пересылают точке или прикладывают к разбору. */
	function downloadCsv() {
		const escape = (value) => `"${String(value ?? '').replace(/"/g, '""')}"`
		const stripTags = (html) => String(html || '')
			.replace(/<\/div>/gi, ' | ')
			.replace(/<[^>]*>/g, ' ')
			.replace(/\s+/g, ' ')
			.replace(/\s*\|\s*$/, '')
			.trim()

		const lines = [['#', 'Дата', 'Пользователь', 'Устройство', 'Действие'].map(escape).join(';')]

		logs.forEach((item, index) => {
			lines.push([
				index + 1,
				formatPosDate(item.created_at, 'dd.MM.yyyy HH:mm:ss'),
				item.created_by_name || item.created_by,
				parseJson(item.params)?.device_name,
				stripTags(logMessage(item.params)),
			].map(escape).join(';'))
		})

		// BOM — иначе Excel открывает кириллицу как кракозябры.
		const blob = new Blob(['﻿' + lines.join('\r\n')], { 'type': 'text/csv;charset=utf-8;' })
		const url = URL.createObjectURL(blob)
		const link = document.createElement('a')

		link.href = url
		link.download = `cheque-${cheque?.cheque_number ?? cheque?.id}-history.csv`
		link.click()

		URL.revokeObjectURL(url)
	}

	return (
		<Modal show={show} animation={false} centered size="lg" onHide={onHide}>
			<Modal.Header closeButton>
				<Modal.Title>
					История чека №{cheque?.cheque_number ?? cheque?.id}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div style={{ 'height': '400px', 'overflow': 'auto' }}>
					<table className="table table-bordered">
						<thead>
							<tr>
								<th className="text-center" style={{ 'width': '33px' }}>#</th>
								<th style={{ 'width': '110px' }}><b>Дата</b></th>
								<th style={{ 'width': '140px' }}><b>Пользователь</b></th>
								<th><b>Действие</b></th>
							</tr>
						</thead>
						<tbody>
							{logs.map((item, index) => (
								<tr key={item.id ?? index}>
									<td className="text-center">{index + 1}</td>
									<td className="text-nowrap">{formatPosDate(item.created_at, 'dd.MM HH:mm')}</td>
									<td className="td-ellipsis">
										<div title={item.created_by}>
											{item.created_by_name || item.created_by}
										</div>
										{parseJson(item.params)?.device_name &&
											<div className="text-muted fz12"
												title={parseJson(item.params).device_name}>
												{parseJson(item.params).device_name}
											</div>
										}
									</td>
									<td>
										<div dangerouslySetInnerHTML={{ __html: logMessage(item.params) }} />
									</td>
								</tr>
							))}

							{logs.length === 0 &&
								<tr>
									<td colSpan="4" className="text-center text-muted">
										{loading
											? 'Загрузка…'
											: 'Записей нет — либо действий по чеку не было, либо версия кассы историю ещё не ведёт'}
									</td>
								</tr>
							}
						</tbody>
					</table>
				</div>
			</Modal.Body>
			<Modal.Footer>
				<button type="button" className="btn btn-outline-secondary"
					disabled={logs.length === 0}
					onClick={() => downloadCsv()}>
					Скачать CSV
				</button>
				<button type="button" className="btn btn-primary" onClick={onHide}>
					Закрыть
				</button>
			</Modal.Footer>
		</Modal>
	)
}

export default ChequeLogsModal
